export function getMockSub() {
  try {
    const raw = localStorage.getItem("prepmate_mock_subscription");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setMockSub(sub) {
  localStorage.setItem("prepmate_mock_subscription", JSON.stringify(sub));
}

export function clearMockSub() {
  localStorage.removeItem("prepmate_mock_subscription");
}

export function getCheckoutDraft() {
  try {
    const raw = localStorage.getItem("prepmate_checkout");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setCheckoutDraft(payload) {
  localStorage.setItem("prepmate_checkout", JSON.stringify(payload));
}

export function clearCheckoutDraft() {
  localStorage.removeItem("prepmate_checkout");
}